// extracted by mini-css-extract-plugin
export default {"root":"a4wIm8pJPu","nameContainer":"jq8Xmiafat","timestamp":"eUTY1LswYS"};